import api from '../../lib/api'
import assign from 'lodash.assign'

const name = 'wps-template-detail'
/**
 * 根据路由参数获取参数
 * @fileName 对应所在目录名称
 * @key 对应所在目录key值
 * */
const PAGE_SIZE = 20
export default {
  name,
  namespaced: true,
  state: {
    totalSize: 1, // 文件总个数
    parentId: '', // 文件所在目录key值
    currentPageNo: 1,  // 当前请求的页面
    totalLists: [],  // 已获取的所有文件
    loading: false,  //  下拉加载状态
    parentName: ''  //  文件所在目录名
  },
  getters: {
    totalPage: (state) => {
      return Math.ceil(state.totalSize / PAGE_SIZE) || 1
    },
    isEnd: (state, getters) => {
      return state.currentPageNo <= getters.totalPage ? false : true
    }
  },
  mutations: {
    set (state, data) {
      assign(state, data)
    }
  },
  actions: {
    async getList ({ state, commit, getters, rootState }) {
      const { fileId, fileName } = rootState.route.query
      const { currentPageNo } = state
      if (currentPageNo <= getters.totalPage) {
        commit('set', { loading: true })
        const { data } = await api.wpsTemplate.getLists(fileId, state.currentPageNo)()
        let totalLists = state.totalLists.concat(data.list)
        commit('set', {
          totalLists,
          totalSize: data.size,
          parentId: fileId,
          parentName: fileName,
          currentPageNo: currentPageNo+1,
          loading: false
        })
      }
    },
    async resetData ({ commit }) {
      commit('set',{
        totalSize: 1,
        parentId: '',
        parentName: '',
        currentPageNo: 1,
        totalLists: [],
        loading: false
      })
    },
    async init ({ dispatch }) {
      await dispatch('getList')
    }
  }
}
